import BottomNavigation from "@material-ui/core/BottomNavigation";
import styled from "styled-components";

export const StyledBottomNavigation = styled(BottomNavigation)`
    position: absolute;
    bottom: 0;
`;
